module.exports = __webpack_public_path__ + "static/media/4.8ec805f9.jpeg";